var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":'tinymce_title_' + _vm.editorId,"inline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }